var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentPersonContactsOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.364 10h-4.546v1.364h4.546V10zm-4.546 3.182h4.546v1.364h-4.546v-1.364zm-3.408-2.5a1.59 1.59 0 11-3.182 0 1.59 1.59 0 013.181 0zM5.636 14.66c0-1.059 2.12-1.592 3.182-1.592 1.062 0 3.182.533 3.182 1.591v.795H5.636v-.795z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.818 5A1.818 1.818 0 002 6.818v10.91c0 1.003.814 1.817 1.818 1.817h16.364A1.818 1.818 0 0022 17.727V6.818A1.818 1.818 0 0020.182 5H3.818zm16.364 1.364H3.818a.455.455 0 00-.454.454v10.91c0 .25.203.454.454.454h16.364a.455.455 0 00.454-.455V6.818a.455.455 0 00-.454-.454z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPersonContactsOutline);
export default __webpack_public_path__ + "fea86a9d763a6a8306592dfbc5ad86b2.svg";
export { ForwardRef as ReactComponent };